module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e1556"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#6190AF"
    }
  }, [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toct1",
    attrs: {
      "id": "d7e26a87"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Susa_ISBN9781588169167_epub_fore_r1#d7e2768"
    }
  }, [_vm._v("FOREWORD")])]), _vm._v(" "), _c('p', {
    staticClass: "ser2",
    attrs: {
      "id": "rps6"
    }
  }, [_c('img', {
    attrs: {
      "alt": "page6a",
      "src": "Images/page-6a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "d7e1606"
    }
  }, [_c('i', [_c('a', {
    attrs: {
      "href": "#/Text/Susa_ISBN9781588169167_epub_part01_r1#d7e42011",
      "id": "d14e96"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#DF761B"
    }
  }, [_vm._v("the home that welcomes")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toct",
    attrs: {
      "id": "d7e1656"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Susa_ISBN9781588169167_epub_ch01_r1#d7e44112",
      "id": "d14e99"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#DF761B"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "toct1",
    attrs: {
      "id": "d7e1686"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Susa_ISBN9781588169167_epub_ch01_r1#d7e44012",
      "id": "d14e102"
    }
  }, [_vm._v("WHAT MAKES"), _c('br'), _vm._v("A WELCOMING HOME?")])]), _vm._v(" "), _c('p', {
    staticClass: "toct",
    attrs: {
      "id": "d7e1786"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Susa_ISBN9781588169167_epub_ch02_r1#d7e223728",
      "id": "d14e105",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#DF761B"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "toct1",
    attrs: {
      "id": "d7e1816"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Susa_ISBN9781588169167_epub_ch02_r1#d7e224228",
      "id": "d14e108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CLUTTER CONTROL")])]), _vm._v(" "), _c('p', {
    staticClass: "toct",
    attrs: {
      "id": "d7e1866"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Susa_ISBN9781588169167_epub_ch03_r1#d7e414942",
      "id": "d14e111",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#DF761B"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "toct1",
    attrs: {
      "id": "d7e1896"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Susa_ISBN9781588169167_epub_ch03_r1#d7e415442",
      "id": "d14e114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WHAT MEETS THE EYE")])]), _vm._v(" "), _c('p', {
    staticClass: "ser2"
  }, [_c('img', {
    attrs: {
      "alt": "page6a",
      "src": "Images/page-6b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "d7e1956"
    }
  }, [_c('i', [_c('span', {
    attrs: {
      "href": "#/Text/Susa_ISBN9781588169167_epub_part02_r1#d7e668669",
      "id": "d14e118",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#72A532"
    }
  }, [_vm._v("behind the scenes")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toct",
    attrs: {
      "id": "d7e2006"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Susa_ISBN9781588169167_epub_ch04_r1#d7e670370",
      "id": "d14e121",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#72A532"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "toct1",
    attrs: {
      "id": "d7e2036"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Susa_ISBN9781588169167_epub_ch04_r1#d7e671270",
      "id": "d14e124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE ELEMENTS OF CLEAN")])]), _vm._v(" "), _c('p', {
    staticClass: "toct",
    attrs: {
      "id": "d7e2086"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Susa_ISBN9781588169167_epub_ch05_r1#d7e962394",
      "id": "d14e128",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#72A532"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "toct1",
    attrs: {
      "id": "d7e2116"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Susa_ISBN9781588169167_epub_ch05_r1#d7e963294",
      "id": "d14e131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE TAO OF LAUNDRY")])]), _vm._v(" "), _c('p', {
    staticClass: "ser2",
    attrs: {
      "id": "rps7"
    }
  }, [_c('img', {
    attrs: {
      "alt": "page7a",
      "src": "Images/page-7a.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "d7e2197"
    }
  }, [_c('i', [_c('span', {
    attrs: {
      "href": "#/Text/Susa_ISBN9781588169167_epub_part03_r1#d7e12374111",
      "id": "d14e135",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#59A3CC"
    }
  }, [_vm._v("in the kitchen")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toct",
    attrs: {
      "id": "d7e2247"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Susa_ISBN9781588169167_epub_ch06_r1#d7e12390112",
      "id": "d14e138",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#59A3CC"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "toct1",
    attrs: {
      "id": "d7e2277"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Susa_ISBN9781588169167_epub_ch06_r1#d7e12399112",
      "id": "d14e141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("KITCHEN WISDOM")])]), _vm._v(" "), _c('p', {
    staticClass: "toct",
    attrs: {
      "id": "d7e2327"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Susa_ISBN9781588169167_epub_ch07_r1#d7e15047128",
      "id": "d14e144",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#59A3CC"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "toct1",
    attrs: {
      "id": "d7e2357"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Susa_ISBN9781588169167_epub_ch07_r1#d7e15056128",
      "id": "d14e147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE A–Z OF FOOD")])]), _vm._v(" "), _c('p', {
    staticClass: "toct",
    attrs: {
      "id": "d7e2407"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Susa_ISBN9781588169167_epub_ch08_r1#d7e18376149",
      "id": "d14e150",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#59A3CC"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "toct1",
    attrs: {
      "id": "d7e2437"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Susa_ISBN9781588169167_epub_ch08_r1#d7e18385149",
      "id": "d14e153",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("BETTER LIVING"), _c('br'), _vm._v("THROUGH BAKING")])]), _vm._v(" "), _c('p', {
    staticClass: "ser2"
  }, [_c('img', {
    attrs: {
      "alt": "page7b",
      "src": "Images/page-7b.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "d7e2517"
    }
  }, [_c('i', [_c('span', {
    attrs: {
      "href": "#/Text/Susa_ISBN9781588169167_epub_part04_r1#d7e21806175",
      "id": "d14e157",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#C085A3"
    }
  }, [_vm._v("harmony")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toct",
    attrs: {
      "id": "d7e2577"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Susa_ISBN9781588169167_epub_ch09_r1#d7e21820176",
      "id": "d14e160",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#C085A3"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "toct1",
    attrs: {
      "id": "d7e2607"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Susa_ISBN9781588169167_epub_ch09_r1#d7e21829176",
      "id": "d14e164",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IN THE GARDEN")])]), _vm._v(" "), _c('p', {
    staticClass: "toct",
    attrs: {
      "id": "d7e2657"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Susa_ISBN9781588169167_epub_ch10_r1#d7e24626200",
      "id": "d14e167",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#C085A3"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "toct1",
    attrs: {
      "id": "d7e2687"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Susa_ISBN9781588169167_epub_ch10_r1#d7e24635200",
      "id": "d14e170",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A GREENER LIFE")])]), _vm._v(" "), _c('p', {
    staticClass: "toct2",
    attrs: {
      "id": "d7e2687a"
    }
  }, [_vm._v("_________________________________")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e903bdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Susa_ISBN9781588169167_epub_toc_r1.vue
// module id = 72
// module chunks = 0